'use strict';

var remoteStuctureFetcher = require('@wix/blocks-widget-services/remoteStructureFetcher');

var getAppDescriptor = remoteStuctureFetcher.getAppDescriptor,
    getWidgetStructureByAppData = remoteStuctureFetcher.getWidgetStructureByAppData,
    getWidgetStructure = remoteStuctureFetcher.getWidgetStructure;
module.exports = {
  getWidgetStructure: getWidgetStructure,
  getAppDescriptor: getAppDescriptor,
  getWidgetStructureByAppData: getWidgetStructureByAppData
};
//# sourceMappingURL=remoteStructureFetcher.js.map